import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class IndividualClaimSubmissionService {
  
  routePrefix = "/api/individual-claim-submission";
  requestTokenKey = 'requestToken';
  requestToken: string;
  constructor(private http: HttpClient) { }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  clearRequestToken() {
    sessionStorage.removeItem(this.requestTokenKey);
  }

  otpValidationIndividual(otp: string, claimSubmitterMobileNumber: string): Observable<any> {
    const body = {
      otp: otp,
      claimSubmitterMobileNumber: claimSubmitterMobileNumber,
    };
    return this.http.post(this.routePrefix + "/otp-validation-individual", body, { headers: this.getRequestTokenHeader() });
  }

  authenticateClaimSubmitter(indClaimSubmissionOtpVm: any): Observable<any> {
    return this.http.post(this.routePrefix + "/authenticate-claim-submitter", indClaimSubmissionOtpVm);
  }

  validatePolicyData(validatePolicyDataVm: any): Observable<any> {
    return this.http.post(this.routePrefix + "/validate-policy-data", validatePolicyDataVm, { headers: this.getRequestTokenHeader() });
  }

  getRequiredDocuments(): Observable<any> {
    return this.http.get(this.routePrefix + "/required-documents");
  }

  getRequiredDocumentsBasedOnIncident(): Observable<any> {
    return this.http.get(this.routePrefix + "/document-based-on-incident");
  }

  claimSubmission(data): Observable<any> {
      return this.http.post(this.routePrefix + "/add", data, { headers: this.getRequestTokenHeader() });
  }

  validateIndividualClaim(validateClaimRequestVm): Observable<any> {
    return this.http.post(this.routePrefix + "/validateIndividualClaim", validateClaimRequestVm);
  }

  getDocumentsAndPatientName(
    claimEntryId: number
  ): Observable<any> {
    const body = {
      claimEntryId: claimEntryId
    }
    return this.http.post(this.routePrefix + "/getDocumentsAndPatientName", body, { headers: this.getRequestTokenHeader() });
  }

  additionalDocumentSubmitInd(data): Observable<any> {
    return this.http.post(this.routePrefix + "/additionalDocumentSubmission", data, { headers: this.getRequestTokenHeader() });
}

}
